<template>
	<div class="login">
		<!-- <div class="close-btn" @click="changeRouteHome">
      <i class="icon-x"></i>
    </div> -->
		<div class="g-content">
			<div class="login-head">

				<div style="display: block;">
					<div class="cu-custom" style="height: 45px;">
						<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
							<div class="content text-gold" style="top: 0px;">
								<div>{{$t('deglu')}}</div>
							</div>
							<div style="margin-left: 34px;" @click="changeLanguage">
								<text style="margin-left: -20px; font-size: 14px;">
									<span>{{$t('jiantizhongwen')}}</span>
								</text>
							</div>
						</div>
					</div>
				</div>

				<img src="@/assets/home/31.png" class="app-logo" alt="" />
				<div style=" margin-top: 23px; margin-left: 35px;"><span
						style=" font-size: 21px;  color: #b8a78a;">Forex Gold USA</span></div>
			</div>
			<van-cell-group class="login-body van-cell-group">
				<van-field :placeholder="$t('plusername')" v-model="username" clearable>
					<template #left-icon>
						<img src="@/assets/home/33.png" class="left-form-icon" alt="" />
					</template>
				</van-field>
				<van-field clearable :placeholder="$t('plpassword')" type="password" v-model="password">
					<template #left-icon>
						<img src="@/assets/home/34.png" class="left-form-icon" alt="" />
					</template>
				</van-field>
				<div class="field-container">
					<van-field clearable :placeholder="$t('yanzhengma')" type="text" v-model="yzm">

						<template #left-icon>
							<img src="@/assets/home/36.png" class="left-form-icon" alt="" />

						</template>
					</van-field>
					<div class="overlay-image">
						<Captcha ref="Captcha" />
					</div>
				</div>
				<!-- <van-cell>
						<template #title>
						<van-checkbox v-model="checked"><span class="c_a0a0a0">{{ $t("jizhumima") }}</span>
						</van-checkbox>
					</template>
					<template #value>
						<span class="c_a0a0a0" @click="changePWDho">{{ $t("wangjimima") }}?</span>
					</template>
				</van-cell> -->
				<div class="denglu" @click="changeHome">
					<button type="primary" round block class="Btnlogin">{{ $t("denglu") }}</button>
				</div>
				<!-- 	<van-cell>
					<van-button type="primary" round block class="Btnlogin"
						@click="changeHome">{{ $t("denglu") }}</van-button>
				</van-cell> -->
				<div class="container">
					<div>
						<span style="color: #b8a78a; font-size: 14px;">{{ $t("meyou") }}?&nbsp;&nbsp;</span>
						<button type="primary" round size="normal" class="TxtBtn"
							@click="changeRegister">{{ $t("zhucezhanghao") }}</button>
					</div>
					<div @click="handleKefuClick">
						<span class="c_a0a0a0" @click="handleKefuClick">{{ $t("wangjimima") }}</span>
					</div>
				</div>
				<!-- 	<van-cell>
					<template #title>
						<div class="content open-visitor">
							<van-button type="primary" round size="normal" class="TxtBtn"
								@click="changeTourist">{{ $t("youkedenglu") }}</van-button>
							<van-button type="primary" round size="normal" class="TxtBtn"
								@click="changeRegister">{{ $t("zhucezhanghao") }}</van-button>
						</div>
					</template>
				</van-cell> -->

			</van-cell-group>
			<div class="cu-modal " :class="{'show': showLangModal}" @click.self="showLangModal = false">
				<div class=" cu-dialog" style="width: 60%;margin-top: 200px;margin-left: 80px;">
					<div class="cu-list menu">
						<div class="cu-item text-gold" @click="languageSet(3)">
							<label class="flex justify-between align-center flex-sub uni-label-pointer" value="en">
								<div class="flex-sub">English</div>
							</label>
						</div>
						<div class="cu-item text-gold" @click="languageSet(2)">
							<label class="flex justify-between align-center flex-sub uni-label-pointer" value="zh-Hans">
								<div class="flex-sub">繁體中文</div>
							</label>
						</div>
						<div class="cu-item text-gold" @click=" languageSet(1)">
							<label class="flex justify-between align-center flex-sub uni-label-pointer" value="zh-Hant">
								<div class="flex-sub">简体中文</div>
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--   <p class="app-version">{{ $t("dangqianbanben") }}：21.04.02</p> -->
		<alert-pop :alertType="3" :Tips="TipsTxt" v-if="PopAlert" @showAletfalse="showAletfalse"></alert-pop>
	</div>
</template>

<script>
	// @ is an alias to /src
	import loginApi from "@/api/login";
	import Captcha from "@/components/tabbar/Captcha.vue";
	import storeAction from "@/store/typed-actions";
	import AlertPop from "@/components/alert/AlertPop.vue";
	import homeApi from "@/api/home";
	export default {
		name: "Login",
		components: {
			AlertPop,
			Captcha,
		},
		data() {
			return {

				checked: true,
				username: "",
				password: "",
				PopAlert: false,
				TipsTxt: this.$t('Tips.wjmm'),
				captchaValue: "",
				yzm: "",
				showLangModal: false,
			};
		},
		methods: {
			languageSet(type) {
				if (type == 0) {
					localStorage.setItem("locale", "zh");
					localStorage.setItem("localetype", type);
					this.show = 0;
				} else if (type == 1) {
					localStorage.setItem("locale", "zh");
					localStorage.setItem("localetype", type);
					this.show = 1;
				} else if (type == 2) {
					localStorage.setItem("locale", "tw");
					localStorage.setItem("localetype", type);
					this.show = 2;
				} else if (type == 3) {
					localStorage.setItem("locale", "en");
					localStorage.setItem("localetype", type);
					this.show = 3;
				}
				location.reload();
			},
			changeLanguage() {
				this.showLangModal = true
				// this.$router.push({
				// 	path: "/language",
				// });
			},
			handleKefuClick() {
				homeApi.heart("", "")
					.then((data) => {
						// console.log(data, 33322)
						if (data.data.kefu_config) {
							window.location.href = data.data.kefu_config
							// window.open(data.data.kefu_config); // 新窗口打开链接
							// 或使用 location.href = data.data.kefu_config 当前页跳转
						}
					})
					.catch((err) => {
						this.$toast.fail(err);
					});
			},
			changeRegister() {
				this.$router.push({
					path: "/register",
				});
			},
			changeHome() {
				let cc = this.$refs.Captcha.getYam();
				const inputCode = this.yzm.trim();

				console.log('计算结果:', cc, '用户输入:', inputCode);

				if (!inputCode) {
					this.$toast.fail(this.$t('yanzhengma'));
					return false;
				}
				if (inputCode !== String(cc)) { // 直接比较
					this.$toast.fail(this.$t('qsryz'));
					return false;
				}

				if (!this.username) {
					this.$toast(this.$t('plusername'));
				} else if (!this.password) {
					this.$toast(this.$t('plpassword'));
				} else {
					if (this.checked) {
						this.setCookie(this.username, this.password, 14);
					} else {
						this.setCookie("", "", -1);
					}
					loginApi
						.login(this.username, this.password)
						.then((data) => {
							console.log(data.data, this.$t('Tips.dlcg'));
							storeAction.loginDone(data.data);
						})
						.catch((err) => {
							this.$toast.clear();
							this.$toast.fail(err.msg);
						});
				}
			},

			// 游客注册
			changeTourist() {
				if (this.checked) {
					let username =
						this.$t("youke") + Math.floor(new Date(new Date()).getTime() / 1000);
					loginApi
						.register(username, this.randomCoding(), "2", "")
						.then((data) => {
							console.log(data.data, "游客注册成功");
							storeAction.loginDone(data.data);
						})
						.catch((err) => {
							this.$toast.clear();
							this.$toast.fail(err.msg);
						});
					this.setCookie(username, "", 14);
				} else {
					this.setCookie("", "", -1);
				}
			},
			// 忘记密码
			changePWDho() {
				this.$router.push({
					path: "/forget",
				});
			},
			showAletfalse() {
				this.PopAlert = false;
			},
			changeRouteHome() {
				let that = this;
				storeAction.clearCurrentUserId();
				storeAction.clearToken();
				storeAction.delsessionStorage("id");
				storeAction.delsessionStorage("userId");
				storeAction.delsessionStorage("money");
				storeAction.delsessionStorage("idcard");
				storeAction.delsessionStorage("group_id");
				storeAction.setCurrentUserMoney(null);
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 500,
					onClose() {
						that.$router.push(`/`);
					},
				});
			},
			// 随机生成字母
			randomCoding() {
				//创建26个字母数组
				let arr = [
					"A",
					"B",
					"C",
					"D",
					"E",
					"F",
					"G",
					"H",
					"I",
					"J",
					"K",
					"L",
					"M",
					"N",
					"O",
					"P",
					"Q",
					"R",
					"S",
					"T",
					"U",
					"V",
					"W",
					"X",
					"Y",
					"Z",
				];
				let idvalue = "";
				for (let i = 0; i < 6; i++) {
					idvalue += arr[Math.floor(Math.random() * 26)];
				}
				console.log(idvalue, "idvalue");
				return idvalue;
			},
			setCookie(name, pwd, exdays) {
				var exdate = new Date(); // 获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
				// 字符串拼接cookie
				window.document.cookie =
					"userName" + "=" + name + ";path=/;expires=" + exdate.toGMTString();
				window.document.cookie =
					"userPwd" + "=" + pwd + ";path=/;expires=" + exdate.toGMTString();
			},
			// 读取cookie 将用户名和密码回显到input框中
			getCookie() {
				if (document.cookie.length > 0) {
					var arr = document.cookie.split("; "); // 这里显示的格式需要切割一下自己可输出看下
					for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split("="); // 再次切割
						// 判断查找相对应的值
						if (arr2[0] === "userName") {
							this.username = arr2[1]; // 保存到保存数据的地方
							// 其中unescape() 方法是将字符串进行编码，escape()方法是将字符串进行解码。
						} else if (arr2[0] === "userPwd") {
							this.password = arr2[1];
						}
					}
				}
			},
		},
		created() {
			this.getCookie();
		},
	};
</script>
<style lang="less" scoped>
	.cu-modal.show {
		opacity: 0;
		transition-duration: .3s;
		-ms-transform: scale(1);
		-webkit-transform: scale(1);
		transform: scale(1);
		overflow-x: hidden;
		overflow-y: auto;
		pointer-events: auto;
	}

	.cu-modal {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 1110;
		opacity: 0;
		outline: 0;
		text-align: center;
		transform: scale(1.185);
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
		perspective: 1146px;
		background: rgba(0, 0, 0, .6);
		transition: all .3s ease-in-out 0s;
		pointer-events: none;
	}

	.cu-modal.show {
		opacity: 1;
		pointer-events: auto;
		transform: scale(1);
	}

	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.field-container {
		position: relative;
		width: 100%;
	}

	.overlay-image {
		position: absolute;
		margin-left: 50%;
		top: 50%;
		transform: translateY(-50%);
		width: 35%;
		z-index: 1;
	}

	.container {
		margin-top: 20px;
		margin-left: 52px;
		display: flex;
		justify-content: space-between;
		width: 65%;
	}

	.denglu {
		margin-left: 25px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		box-sizing: border-box;
		width: 85%;
		padding: 10px 16px;
		overflow: hidden;
		color: unset;
		margin-top: 45px;
		font-size: 14px;
		line-height: 24px;
		border-radius: 30px;

		background-color: unset;
	}

	::v-deep .van-button--primary {
		color: #b8a78a;
	}

	::v-deep .van-field__control {
		// margin-left: 60px;
		color: #b8a78a;
	}

	::v-deep .van-field__control::placeholder {
		color: rgb(184, 167, 138);
	}

	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 52px;
		justify-content: space-between;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 228px);
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 176px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 31px;
		font-size: 16px;
		line-height: 31px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-custom {
		display: block;
		position: relative;
	}

	.login {
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		flex-direction: column;
	}

	.close-btn {
		position: absolute;
		padding: 0.3rem;
		z-index: 1;
	}

	.icon-x {
		display: inline-block;
		width: 0.5rem;
		height: 0.07rem;
		background: #fff;
		line-height: 0;
		font-size: 0;
		vertical-align: middle;
		transform: rotate(45deg);
	}

	.icon-x::after {
		content: "";
		display: block;
		width: 0.5rem;
		height: 0.07rem;
		background: #fff;
		transform: rotate(-90deg);
	}

	.g-content {
		flex: 1;
		//   overflow: scroll;
	}

	.login-head {
		position: relative;
		height: 4.9rem;
	}

	.app-logo {
		width: 1.3rem;
		height: 1.3rem;
		border-radius: 0.1rem;
		-o-object-fit: cover;
		/* object-fit: cover; */
		/* position: absolute; */
		left: 50%;
		bottom: 0;
		transform: translate(-180%, 120%);
	}

	.login-body {
		margin-top: 0.7rem;
		padding: 0 0.68rem;
	}

	.van-cell-group {
		background: unset;
		position: unset;

		input {}
	}

	.van-cell {
		margin-left: 25px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		box-sizing: border-box;
		width: 85%;
		padding: 10px 16px;
		overflow: hidden;
		color: unset;
		margin-top: 18px;
		font-size: 14px;
		line-height: 24px;
		border-radius: 30px;
		border: 2px solid #b8a78a;
		background-color: unset;
	}

	.van-field::after {
		position: absolute;
		box-sizing: border-box;
		content: " ";
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 1px solid #3d5179 !important;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}

	.left-form-icon {
		width: 20px;
	}

	.c_a0a0a0 {
		color: #a0a0a0;
		font-size: 14px;
	}

	.Btnlogin {
		margin-left: 120px;
		color: #b8a78a;
		height: 26px;
	}

	.TxtBtn {
		color: #f37b1d;
		font-size: 14px;
	}

	.content {
		// display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.open-visitor {
		justify-content: space-around;
	}

	.app-version {
		text-align: center;
		margin-top: 0.4rem;
		color: #a0a0a0;
	}

	.van-cell::after {
		position: absolute;
		box-sizing: border-box;
		content: " ";
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 0px solid #3d5179;
	}
</style>